import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import VueRouter from 'vue-router';
import vuetify from './plugins/vuetify';
import firebase from 'firebase/app';
import App from './App.vue';
import Calculator from './components/Calculator.vue';
import WeeklySummary from './components/WeeklySummary.vue';
import DailyLog from './components/DailyLog.vue';
import ExerciseLog from './components/ExerciseLog.vue';
import MyWorkout from './components/MyWorkout.vue';

Vue.config.productionTip = false;
Vue.use(VueRouter);

const firebaseConfig = {
    apiKey: "AIzaSyAFejLRchHLc69vGODVcclKKyZEczKsdyo",
    authDomain: "inol-d6d35.firebaseapp.com",
    databaseURL: "https://inol-d6d35.firebaseio.com",
    projectId: "inol-d6d35",
    storageBucket: "",
    messagingSenderId: "259387988374",
    appId: "1:259387988374:web:69cac427a8dd09e2"
};
firebase.initializeApp(firebaseConfig);

const routes = [
    { path: '/calculator', name: 'Calculator', component: Calculator, meta: { title: 'Calculator' } },
    { path: '/weekly_summary', name: 'WeeklySummary', component: WeeklySummary, meta: { title: 'Weekly Summary', requiresAuth: true } },
    { path: '/daily_log', name: 'DailyLog', component: DailyLog, meta: { title: 'Daily Log', requiresAuth: true } },
    { path: '/exercise_log', name: 'ExerciseLog', component: ExerciseLog, meta: { title: 'Exercise Log', requiresAuth: true } },
    { path: '/my_exercise', name: 'MyExercise', component: MyWorkout, meta: { title: 'My Exercise', requiresAuth: true } },
    { path: '*', redirect:'/' },
];

let user = JSON.parse(localStorage.getItem('user'));
if(user){
    routes.push({ path: '/', component: WeeklySummary, meta: { title: 'Weekly Summary', requiresAuth: true } });
}else{
    routes.push({ path: '/', component: Calculator, meta: { title: 'Calculator' } });
}

const router = new VueRouter({
    routes, // `routes: routes`의 줄임
});

new Vue({
    vuetify,
    router,
    render: h => h(App),
}).$mount('#app');
